// @flow
import InitialLoader from './InitialLoader';

export default InitialLoader;
